/**
 * Clé de tri pour les noms affichés (élèves, professeurs).
 * Dérive une chaîne "Nom Prénom" à partir de displayName pour un tri cohérent
 * qu'il soit saisi "Prénom Nom" ou "Nom, Prénom".
 * @param {string} displayName - Nom affiché (libre ou fourni par Google)
 * @returns {string} Chaîne pour orderBy (nom de famille en premier)
 */
export function getSortNameFromDisplayName(displayName) {
  const s = (displayName ?? '').trim().replace(/\s+/g, ' ')
  if (!s) return ''
  if (s.includes(',')) {
    const idx = s.indexOf(',')
    const familyName = s.slice(0, idx).trim()
    const givenName = s.slice(idx + 1).trim()
    return [familyName, givenName].filter(Boolean).join(' ').trim() || s
  }
  const lastSpace = s.lastIndexOf(' ')
  if (lastSpace <= 0) return s
  const familyName = s.slice(lastSpace + 1).trim()
  const givenName = s.slice(0, lastSpace).trim()
  return [familyName, givenName].filter(Boolean).join(' ').trim() || s
}
